import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import SideNav from '../../shared/Sidenav';
import '../../../css/systemConfig/MaintainFacility.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import add from '../../../assets/images/add.svg';
import addDisable from '../../../assets/images/plus_disable.svg';
import edit from '../../../assets/images/edit.svg';
import Button from '../../shared/Button';
import downarrow from '../../../assets/images/drpdwnArrow.svg';
import drawer from '../../../assets/images/arrow-up.svg';
import calendar from '../../../assets/images/calendar.svg';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import SuccessModal from '../../shared/SuccessModal';
import message from '../../../data/Message.json';
import viewAccess from '../../../assets/images/viewOnlyAccess.svg';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { ALLPORTTERMINALS_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
let viewOnly = false;
class MaintainFacility extends React.Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            hasAddRow: false,
            facilityName: "",
            facilityCode: "",
            facilityType: "",
            weatherURL: "",
            integratedWith: "",
            FacilityTypedropdown: false,
            IntegratedWithdropdown: false,
            effectiveDateValue: '',
            showEffectiveCalendar: false,
            expiryDateValue: '',
            showExpiryeCalendar: false,
            isEdit: [],
            FacilityTypedropdownarray: [false],
            IntegratedWithdropdownarray: [false],
            showEffectiveCalendarArray: [false],
            showEfxpiryCalendarArray: [false],
            editIndex: [],
            maintainFacilityData: [],
            confirmedHasOpen: false,
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
        var selectedTiles = [];
        let roleData = this.props.data;
        const roleDataLength = roleData.length;
        for (let z = 0; z < roleDataLength; z++) {
            var rd = roleData[z].permissions;
            selectedTiles.push(rd)
        }
        selectedTiles.map(x =>
            x.map(md => {
                if (md.functionId === 1) {
                    if (md.method.includes("View & Edit")) {
                        viewOnly = true
                    }
                }
                return true;
            }))
        ApiCall(
            'GET',
            utilityBaseURL + ALLPORTTERMINALS_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-cc-trace-id': '1234',
            },
        ).then((apiData) => {
            if (apiData.flag !== -1) {
                if (apiData.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    this.setState({ maintainFacilityData: apiData });
                }
            } else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        });
    }
    validateFormFields = () => {
        let validEdit = [];
        let editIndex = this.state.editIndex.filter((element, i) => i === this.state.editIndex.indexOf(element))
        for (let index = 0; index < editIndex.length; index++) {
            const element = editIndex[index];
            if (this.state.isEdit[element]) {
                validEdit = validEdit.concat(this.state.maintainFacilityData[element].portName.length > 0 &&
                    this.state.maintainFacilityData[element].portCode.length > 0 &&
                    this.state.maintainFacilityData[element].weatherUrl.length > 0)
            }
        }
        return (this.state.facilityName.length > 0 &&
            this.state.facilityCode.length > 0 && this.state.facilityType.length > 0 &&
            this.state.weatherURL.length > 0 &&
            this.state.integratedWith.length > 0 &&
            this.state.effectiveDateValue.length > 0) || (!validEdit.includes(false) && this.state.isEdit.includes(true))
    };
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        let patternCharacter = new RegExp(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/);
        if (!patternCharacter.test(this.state.weatherURL)) {
            formIsValid = false;
            toast(message.validation.validUrl, "!", { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
        }
        if (new Date(this.state.effectiveDateValue).getFullYear() > new Date(this.state.expiryDateValue).getFullYear()) {
            formIsValid = false;
            toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
        }
        if (new Date(this.state.effectiveDateValue).getFullYear() === new Date(this.state.expiryDateValue).getFullYear()) {
            if (new Date(this.state.effectiveDateValue).getMonth() > new Date(this.state.expiryDateValue).getMonth()) {
                formIsValid = false;
                toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
            }
        }
        if (new Date(this.state.effectiveDateValue).getFullYear() === new Date(this.state.expiryDateValue).getFullYear()) {
            if (new Date(this.state.effectiveDateValue).getMonth() === new Date(this.state.expiryDateValue).getMonth()) {
                if (new Date(this.state.effectiveDateValue).getDate() > new Date(this.state.expiryDateValue).getDate()) {
                    formIsValid = false;
                    toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
                }
            }
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    handleEditValidation() {
        let errors = {};
        let formIsValid = true;
        let patternCharacter = new RegExp(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/);
        // console.log("editIndex", this.state.editIndex)
        let editIndex = this.state.editIndex.filter((element, i) => i === this.state.editIndex.indexOf(element))
        // console.log(this.state.editIndex) //[ 1, 4, 5 ]
        for (let index = 0; index < editIndex.length; index++) {
            const element = editIndex[index];
            if (this.state.isEdit[element]) {
                if (!patternCharacter.test(this.state.maintainFacilityData[element].weatherUrl)) {
                    formIsValid = false;
                    toast(message.validation.validUrl, "!", { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                if (this.state.maintainFacilityData[element].portToDate != null) {
                    if (new Date(this.state.maintainFacilityData[element].portFromDate).getFullYear() > new Date(this.state.maintainFacilityData[element].portToDate).getFullYear()) {
                        formIsValid = false;
                        toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
                    }
                    if (new Date(this.state.maintainFacilityData[element].portFromDate).getFullYear() === new Date(this.state.maintainFacilityData[element].portToDate).getFullYear()) {
                        if (new Date(this.state.maintainFacilityData[element].portFromDate).getMonth() > new Date(this.state.maintainFacilityData[element].portToDate).getMonth()) {
                            formIsValid = false;
                            toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
                        }
                    }
                    if (new Date(this.state.maintainFacilityData[element].portFromDate).getFullYear() === new Date(this.state.maintainFacilityData[element].portToDate).getFullYear()) {
                        if (new Date(this.state.maintainFacilityData[element].portFromDate).getMonth() === new Date(this.state.maintainFacilityData[element].portToDate).getMonth()) {
                            if (new Date(this.state.maintainFacilityData[element].portFromDate).getDate() > new Date(this.state.maintainFacilityData[element].portToDate).getDate()) {
                                formIsValid = false;
                                toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
                            }
                        }
                    }
                }
            }
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ FacilityTypedropdown: false });
            this.setState({ IntegratedWithdropdown: false });
            this.setState({ showEffectiveCalendar: false });
            this.setState({ showExpiryeCalendar: false });
            // console.log(this.state.editIndex)
            let editIndex = this.state.editIndex.filter((element, i) => i === this.state.editIndex.indexOf(element))
            // console.log("after dub", this.state.editIndex)
            for (let index = 0; index < editIndex.length; index++) {
                const element = editIndex[index];
                let a = this.state.showEffectiveCalendarArray;
                a[element] = false;
                this.setState({ showEffectiveCalendarArray: a })
                let b = this.state.showEfxpiryCalendarArray;
                b[element] = false;
                this.setState({ showEfxpiryCalendarArray: b })
            }
        }
    };
    FacilityTypedata = [{ name: "Container Based" }, { name: "Non-container Based" }]
    IntegratedWithdata = [{ name: "GCOS" }, { name: "NAVIS" }]
    toggleEffectiveCalendar = () => {
        this.setState({ showEffectiveCalendar: !this.state.showEffectiveCalendar });
    }
    handleActiveFromMonthChanged = (e) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let formatted_date = e.getDate() + "-" + months[e.getMonth()] + "-" + e.getFullYear();
        if (e.getDate() <= 9) {
            formatted_date = "0" + formatted_date;
        }
        this.setState({ effectiveDateValue: formatted_date, showEffectiveCalendar: false })
    }
    toggleExpiryCalendar = () => {
        this.setState({ showExpiryeCalendar: !this.state.showExpiryeCalendar });
    }
    handleActiveToMonthChanged = (e) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let formatted_date = e.getDate() + "-" + months[e.getMonth()] + "-" + e.getFullYear();
        if (e.getDate() <= 9) {
            formatted_date = "0" + formatted_date;
        }
        this.setState({ expiryDateValue: formatted_date, showExpiryeCalendar: false })
    }
    handlechangeFacilityName = (e) => {
        this.setState({ facilityName: e.target.value });
    };
    handlechangeFacilityCode = (e) => {
        this.setState({ facilityCode: e.target.value });
    };
    handlechangeWeatherURL = (e) => {
        this.setState({ weatherURL: e.target.value });
    };
    onAddHandleFacility = () => {
        this.setState({ hasAddRow: true });
        document.getElementById('maintainFacilityContainer').scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
    handleSubmit = (event) => {
        console.log("Submit pressed!");
        let fromTimeStamp = (new Date(this.state.effectiveDateValue)).toString().substring(4, 15);
        let toTimeStamp = (new Date(this.state.expiryDateValue)).toString().substring(4, 15);
        console.log(fromTimeStamp, toTimeStamp, Date.parse(fromTimeStamp), Date.parse(toTimeStamp))
        let editedFacility = [];
        if (this.state.isEdit.length > 0) {
            if (this.handleEditValidation()) {
                let editIndex = this.state.editIndex.filter((element, i) => i === this.state.editIndex.indexOf(element))
                for (let index = 0; index < editIndex.length; index++) {
                    const element = editIndex[index];
                    if (this.state.isEdit[element] === true) {
                        editedFacility.push(this.state.maintainFacilityData[element])
                    }
                }
                ApiCall(
                    'PUT',
                    utilityBaseURL + ALLPORTTERMINALS_ENDPOINT,
                    editedFacility,
                    {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-cc-trace-id': '1234',
                    }
                ).then(apiData => {
                    if (apiData.flag !== -1) {
                        if (apiData.flag === 500) {
                            toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                        }
                        else {
                            console.log('I am 200!');
                            this.setState({ confirmedHasOpen: true });
                        }
                    }
                    else {
                        // toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                    }
                })
            }
        }
        else {
            if (this.handleValidation()) {
                ApiCall(
                    'POST',
                    utilityBaseURL + ALLPORTTERMINALS_ENDPOINT,
                    {
                        "integrated_with": this.state.integratedWith,
                        "portCode": this.state.facilityCode,
                        "portFromDate": Date.parse(fromTimeStamp),
                        "portName": this.state.facilityName,
                        "portToDate": isNaN(this.state.expiryDateValue) ? Date.parse(toTimeStamp) : null,
                        "portType": this.state.facilityType,
                        "weatherUrl": this.state.weatherURL
                    },
                    {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-cc-trace-id': '1234',
                    }
                ).then(data => {
                    if (data.flag !== -1) {
                        if (data.flag === 500) {
                            toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                        }
                        else {
                            console.log('I am 200!');
                            this.setState({ confirmedHasOpen: true })
                        }
                    }
                    else {
                        //toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
                    }
                })
            }
        }
    }
    onCloseConfirmed = () => {
        this.setState({ confirmedHasOpen: false });
        window.location.reload();
    }
    toggleDropdownFacilityType = () => {
        this.setState({ FacilityTypedropdown: !this.state.FacilityTypedropdown });
    };
    changeRoleTypeFacilityType = (event) => {
        const found = this.FacilityTypedata.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
            return true;
        })
        this.setState({ facilityType: found.name });
        this.setState({ FacilityTypedropdown: !this.state.FacilityTypedropdown });
    }
    toggleDropdownIntegratedWith = () => {
        this.setState({ IntegratedWithdropdown: !this.state.IntegratedWithdropdown });
    };
    changeRoleTypeIntegratedWith = (event) => {
        const found = this.IntegratedWithdata.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
            return true;
        })
        this.setState({ integratedWith: found.name });
        this.setState({ IntegratedWithdropdown: !this.state.IntegratedWithdropdown });
    }
    romoveAddRow = () => {
        this.setState({
            hasAddRow: false,
            facilityName: '',
            facilityCode: '',
            facilityType: '',
            weatherURL: '',
            integratedWith: '',
            effectiveDateValue: '',
            expiryDateValue: ''
        })
    }
    getDateFormate = (dateString) => {
        let date = new Date(Number(dateString)).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    renderTableHeader() {
        return (
            <>
                <tr class="bg-white" id="tableHeader">
                    <td id="col1main" className="tableHeading">Facility Name</td>
                    <td id="col2main" className="tableHeading">Facility Code</td>
                    <td id="col3main" className="tableHeading">Facility Type</td>
                    <td id="col4main" className="tableHeading">Weather URL</td>
                    <td id="col5main" className="tableHeading">Integrated With</td>
                    <td id="col6main" className="tableHeading">Active From Date</td>
                    <td id="col7main" className="tableHeading">Active To Date</td>
                    <td id="col8main" className="tableHeading" style={{ display: !viewOnly ? "none" : null }}></td>
                </tr>
            </>
        )
    }
    renderTableData() {
        return this.state.maintainFacilityData.map((details, index) => {
            let drop1 = this.state.FacilityTypedropdownarray[index] ? <img src={drawer} alt="" /> : <img src={downarrow} alt="" />
            let drop2 = this.state.IntegratedWithdropdownarray[index] ? <img src={drawer} alt="" /> : <img src={downarrow} alt="" />
            return (
                <>
                    {(!this.state.isEdit[index]) ?
                        <tr key={index} id="maintainFacilityData">
                            <td id="facilityNameData" className="tabledatamain">{details.portName}</td>
                            <td id="facilityCodeData" className="tabledatamain">{details.portCode}</td>
                            <td id="facilityTypeData" className="tabledatamain">{details.portType}</td>
                            <td id="weatherUrlData" className="tabledatamain">{details.weatherUrl}</td>
                            <td id="integrateWithData" className="tabledatamain">{details.integrated_with}</td>
                            <td id="activeFromDateData" className="tabledatamain">{
                                details.portFromDate == null ? null :
                                    this.getDateFormate(details.portFromDate)}</td>
                            <td id="activeToDateData" className="tabledatamain">{
                                details.portToDate == null ? null :
                                    this.getDateFormate(details.portToDate)}</td>
                            <td id="editIconMainBody" className="tabledatamain" style={{ display: !viewOnly ? "none" : null }}>
                                <div id="editIconDiv">
                                    <img
                                        src={(this.state.isEdit[index]) ? require('../../../assets/images/editenable.svg') : require('../../../assets/images/edit.svg')}
                                        width="32" height="32" alt="" loading="lazy"
                                        class="editimagetable"
                                        onClick={() => {
                                            let a = this.state.isEdit;
                                            a[index] = !this.state.isEdit[index];

                                            let x = [...this.state.editIndex];
                                            x.push(index)
                                            this.setState({
                                                isEdit: a
                                                , editIndex: x
                                            });
                                        }}
                                    />
                                </div>
                            </td>
                        </tr>
                        :
                        <tr class="" id="maintainFacilityData">
                            <td class="tabledatamain">
                                {<div class="">
                                    <input
                                        className="facilityname"
                                        autoComplete="off"
                                        id="facilitynameid"
                                        value={details.portName}
                                        onChange={(e) => {
                                            this.state.maintainFacilityData[index].portName = e.target.value;
                                            this.setState({ maintainFacilityData: this.state.maintainFacilityData })
                                        }}
                                    ></input>
                                </div>}
                            </td>
                            <td className="tabledatamain">
                                {<div class="">
                                    <input
                                        className="facilityname"
                                        autoComplete="off"
                                        id="facilitycodeid"
                                        value={details.portCode}
                                        onChange={(e) => {
                                            this.state.maintainFacilityData[index].portCode = e.target.value;
                                            this.setState({ maintainFacilityData: this.state.maintainFacilityData })
                                        }}
                                    ></input>
                                </div>}
                            </td>
                            <td className="tabledatamain">
                                {<div class="">
                                    <div className="pass-wrapper" id="facilityTypeDropdown" >
                                        <input
                                            readOnly
                                            placeholder="--Select Type--"
                                            type="text" id="maintainFacilityDropdownInputBox"
                                            value={details.portType}
                                        />
                                        <i
                                            onClick={() => {
                                                let a = this.state.FacilityTypedropdownarray;
                                                a[index] = !this.state.FacilityTypedropdownarray[index];
                                                this.setState({ FacilityTypedropdownarray: a });
                                            }}
                                        >{drop1}</i>
                                    </div>
                                    {this.state.FacilityTypedropdownarray[index] && (
                                        <div class="maintainFacilityDropdownOuter" >
                                            <div class="facilityTypeDropdownOutline" ref={this.container} >
                                                {(this.FacilityTypedata.map((name, i) => {
                                                    return (
                                                        <table class='maintainFacilityDropdownData'
                                                        >
                                                            <td class="maintainFacilityDropdownRow"
                                                                onClick={(e) => {
                                                                    this.state.maintainFacilityData[index].portType = e.target.innerText;
                                                                    this.setState({ maintainFacilityData: this.state.maintainFacilityData })
                                                                    let x = this.state.FacilityTypedropdownarray;
                                                                    x[index] = false;
                                                                    this.setState({ FacilityTypedropdownarray: x });
                                                                }}
                                                            >
                                                                <small class="" id="maintainfacilityDropdowns" >{name.name} </small>
                                                            </td>
                                                        </table>
                                                    );
                                                }))}
                                            </div>
                                        </div>
                                    )}
                                </div>}
                            </td>
                            <td className="tabledatamain">
                                {<div class="">
                                    <input
                                        className="facilityname"
                                        autoComplete="off"
                                        id="weatherURLid"
                                        value={details.weatherUrl}
                                        onChange={(e) => {
                                            this.state.maintainFacilityData[index].weatherUrl = e.target.value;
                                            this.setState({ maintainFacilityData: this.state.maintainFacilityData })
                                        }}
                                    ></input>
                                </div>}
                            </td>
                            <td className="tabledatamain">
                                {<div class="">
                                    <div className="pass-wrapper"
                                        id="facilityTypeDropdown"
                                    >
                                        <input
                                            readOnly
                                            placeholder="--Select Type--"
                                            type="text" id="maintainFacilityDropdownInputBox"
                                            value={details.integrated_with}
                                        />
                                        <i
                                            onClick={() => {
                                                let a = this.state.IntegratedWithdropdownarray;
                                                a[index] = !this.state.IntegratedWithdropdownarray[index];
                                                this.setState({ IntegratedWithdropdownarray: a });
                                            }}
                                        >{drop2}</i>
                                    </div>
                                    {this.state.IntegratedWithdropdownarray[index] && (
                                        <div class="maintainFacilityDropdownOuter" >
                                            <div class="integrateWithDropdownOutline" ref={this.container} >
                                                {(this.IntegratedWithdata.map((name, i) => {
                                                    return (
                                                        <table class='maintainFacilityDropdownData'
                                                        >
                                                            <td class="maintainFacilityDropdownRow"
                                                                onClick={(e) => {
                                                                    this.state.maintainFacilityData[index].integrated_with = e.target.innerText;
                                                                    this.setState({ maintainFacilityData: this.state.maintainFacilityData })
                                                                    let x = this.state.IntegratedWithdropdownarray;
                                                                    x[index] = false;
                                                                    this.setState({ IntegratedWithdropdownarray: x });
                                                                }}
                                                            >
                                                                <small class="" id="maintainfacilityDropdowns" >{name.name} </small>
                                                            </td>
                                                        </table>
                                                    );
                                                }))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                }
                            </td>
                            <td className="tabledatamain">
                                {<div class="">
                                    <div className="pass-wrapper"
                                        id="facilityDropdown"
                                    >
                                        <input
                                            readOnly
                                            class="facilitynamecalender"
                                            placeholder="Select Date"
                                            type="text" id="maintainFacilityCalendarInputBox"
                                            value={
                                                details.portFromDate == null ? null :
                                                    this.getDateFormate(details.portFromDate)}
                                        />
                                        <div
                                        >
                                            <div
                                                class="maintainFacilityEditCalender"
                                            >  {this.state.showEffectiveCalendarArray[index] ? <div ref={this.container}> <Calendar
                                                onChange={(e) => {
                                                    this.state.maintainFacilityData[index].portFromDate = Date.parse(e);
                                                    let showEffectiveCalendar = this.state.showEffectiveCalendarArray;
                                                    showEffectiveCalendar[index] = false;
                                                    this.setState({ maintainFacilityData: this.state.maintainFacilityData, showEffectiveCalendarArray: showEffectiveCalendar })
                                                }}
                                                minDate={new Date
                                                    ()} /></div> : null}</div>
                                        </div><img
                                            src={calendar}
                                            alt=""
                                            onClick={() => {
                                                let a = this.state.showEffectiveCalendarArray;
                                                a[index] = true;
                                                let x = [...this.state.editIndex];
                                                x.push(index)
                                                this.setState({
                                                    showEffectiveCalendarArray: a,
                                                    editIndex: x
                                                })
                                            }}
                                        />
                                    </div>
                                </div>}
                            </td>
                            <td className="tabledatamain">
                                {<div class="">
                                    <div className="pass-wrapper"
                                        id="facilityDropdown"
                                    >
                                        <input
                                            readOnly
                                            class="facilitynamecalender"
                                            placeholder="Select Date"
                                            type="text" id="maintainFacilityCalendarInputBox"
                                            value={
                                                details.portToDate == null ? null :
                                                    this.getDateFormate(details.portToDate)}
                                        />
                                        <div>
                                            <div
                                                className="maintainFacilityEditToCalender"
                                            >  {this.state.showEfxpiryCalendarArray[index] ? <div ref={this.container}> <Calendar
                                                onChange={(e) => {
                                                    this.state.maintainFacilityData[index].portToDate = Date.parse(e);
                                                    let showExpiryeCalendar = this.state.showEfxpiryCalendarArray;
                                                    showExpiryeCalendar[index] = false;
                                                    this.setState({ maintainFacilityData: this.state.maintainFacilityData, showEfxpiryCalendarArray: showExpiryeCalendar })
                                                }}
                                                minDate={new Date(this.state.maintainFacilityData[index].portFromDate)}
                                            /></div> : null}</div>
                                        </div><img
                                            src={calendar}
                                            alt=""
                                            onClick={() => {
                                                let a = this.state.showEfxpiryCalendarArray;
                                                a[index] = true;
                                                let x = [...this.state.editIndex];
                                                x.push(index)
                                                this.setState({
                                                    showEfxpiryCalendarArray: a,
                                                    editIndex: x
                                                })
                                            }}
                                        ></img>
                                    </div>
                                </div>}
                            </td>
                            <td id="editIconMainBody" className="tabledatamain">
                                <div id="editIconDiv">
                                    <img
                                        src={(this.state.isEdit[index]) ? require('../../../assets/images/cross.svg') : require('../../../assets/images/edit.svg')}
                                        width="32" height="32" alt="" loading="lazy"
                                        class="editimagetable"
                                        onClick={() => {
                                            let a = this.state.isEdit;
                                            a[index] = !this.state.isEdit[index];
                                            this.setState({ isEdit: a });
                                        }}
                                    />
                                </div>
                            </td>
                        </tr>}
                </>
            )
        })
    }
    render() {
        let drop1 = this.state.FacilityTypedropdown ? <img src={drawer} alt="" /> : <img src={downarrow} alt="" />
        let drop2 = this.state.IntegratedWithdropdown ? <img src={drawer} alt="" /> : <img src={downarrow} alt="" />
        return (
            <div>
                <MetaDecorator title={TitleDescription.maintainFacilityPageTitle} description={TitleDescription.maintainFacilityPageDescription} />
                <div className="outer1"><div className="outer1" id="outerdiv">
                    <div className="systemConfigMaintainFacilityContainer">
                        <SideNav />
                        <div id="systemConfigtPart">
                            <h1 id='maintainFacilityHeadingTitle'>Maintain Facility</h1>
                            {/* View Only Access */}
                            <div className="viewOnlyDiv" style={{ display: !viewOnly ? null : "none" }}>
                                <img alt="View Only Access" src={viewAccess} />
                                <span className="viewOnly">View Only Access</span>
                            </div>
                            <div className="contentbox">
                                <div className="maintainFacilityMainData" id="maintainFacilityContainer">
                                    <table id='maintainfacilitytabdetails'>
                                        <thead className="adHeading">
                                            {this.renderTableHeader()}
                                        </thead>
                                        <tbody >
                                            {this.state.hasAddRow &&
                                                <tr
                                                    id="maintainFacilityData"
                                                >
                                                    <td class="tabledatamain">
                                                        {<div class="">
                                                            <input
                                                                className="facilityname"
                                                                autoComplete="off"
                                                                id="facilitynameid"
                                                                onChange={this.handlechangeFacilityName}
                                                                value={this.state.facilityName}
                                                            ></input>
                                                        </div>}
                                                    </td>
                                                    <td className="tabledatamain">
                                                        {<div class="">
                                                            <input
                                                                className="facilityname"
                                                                autoComplete="off"
                                                                id="facilitycodeid"
                                                                onChange={this.handlechangeFacilityCode}
                                                                value={this.state.facilityCode}
                                                            ></input>
                                                        </div>}
                                                    </td>
                                                    <td className="tabledatamain">
                                                        {<div class="">
                                                            <div className="pass-wrapper" id="facilityTypeDropDown" >
                                                                <input
                                                                    readOnly class="form-control form-control-sm" placeholder="- - Select Type - -"
                                                                    type="text" id="maintainFacilityDropdownInputBox" value={this.state.facilityType}
                                                                />
                                                                <i id="facilityDropdownIcon" onClick={this.toggleDropdownFacilityType}>{drop1}</i>
                                                            </div>
                                                            {this.state.FacilityTypedropdown && (
                                                                <div class="maintainFacilityDropdownOuter" >
                                                                    <div class="facilityTypeDropdownOutline" ref={this.container} >
                                                                        {(this.FacilityTypedata.map((name, index) => {
                                                                            return (
                                                                                <table class='maintainFacilityDropdownData' onClick={(index1) => this.changeRoleTypeFacilityType(index1)}>
                                                                                    <td class="maintainFacilityDropdownRow"  >
                                                                                        <small class="" id="maintainfacilityDropdowns" >{name.name} </small>
                                                                                    </td>
                                                                                </table>
                                                                            );
                                                                        }))}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>}
                                                    </td>
                                                    <td className="tabledatamain">
                                                        {<div class="">
                                                            <input
                                                                className="facilityname"
                                                                autoComplete="off"
                                                                id="weatherURLid"
                                                                onChange={this.handlechangeWeatherURL}
                                                                value={this.state.weatherURL}
                                                            ></input>
                                                        </div>}
                                                    </td>
                                                    <td className="tabledatamain">
                                                        {<div class="">
                                                            <div className="pass-wrapper" id="facilityTypeDropDown" >
                                                                <input
                                                                    readOnly class="form-control form-control-sm" placeholder="- - Select Site - -"
                                                                    type="text" id="maintainFacilityDropdownInputBox" value={this.state.integratedWith}
                                                                />
                                                                <i id="facilityDropdownIcon" onClick={this.toggleDropdownIntegratedWith}>{drop2}</i>
                                                            </div>
                                                            {this.state.IntegratedWithdropdown && (
                                                                <div class="maintainFacilityDropdownOuter" >
                                                                    <div class="integrateWithDropdownOutline" ref={this.container} >
                                                                        {(this.IntegratedWithdata.map((name, index) => {
                                                                            return (
                                                                                <table class='maintainFacilityDropdownData' onClick={(index1) => this.changeRoleTypeIntegratedWith(index1)}>
                                                                                    <td class="maintainFacilityDropdownRow"  >
                                                                                        <small class="" id="maintainfacilityDropdowns" >{name.name} </small>
                                                                                    </td>
                                                                                </table>
                                                                            );
                                                                        }))}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        }
                                                    </td>
                                                    <td className="tabledatamain">
                                                        {<div class="">
                                                            <div className="pass-wrapper" id="facilityTypeDropDown" >
                                                                <input
                                                                    readOnly
                                                                    class="facilitynamecalender"
                                                                    placeholder="Select Date"
                                                                    type="text" id="maintainFacilityCalendarInputBox"
                                                                    value={this.state.effectiveDateValue}
                                                                />
                                                                <div>
                                                                    <div class="maintainFacilityCalender">  {this.state.showEffectiveCalendar ? <div ref={this.container}> <Calendar onChange={this.handleActiveFromMonthChanged} minDate={new Date()} /></div> : null}</div>
                                                                </div><img id="facilityDropdownIcon" src={calendar} onClick={this.toggleEffectiveCalendar} alt=""></img>
                                                            </div>
                                                        </div>}
                                                    </td>
                                                    <td className="tabledatamain">
                                                        {<div class="">
                                                            <div className="pass-wrapper" id="facilityTypeDropDown" >
                                                                <input
                                                                    readOnly
                                                                    class="facilitynamecalender"
                                                                    placeholder="Select Date"
                                                                    type="text" id="maintainFacilityCalendarInputBox"
                                                                    value={this.state.expiryDateValue}
                                                                />
                                                                <div>
                                                                    <div class="maintainFacilityToDateCalender">  {this.state.showExpiryeCalendar ? <div ref={this.container}> <Calendar onChange={this.handleActiveToMonthChanged}
                                                                        minDate={new Date(this.state.effectiveDateValue)} /></div> : null}</div>
                                                                </div><img id="facilityDropdownIcon" src={calendar} onClick={this.toggleExpiryCalendar} alt="" />
                                                            </div>
                                                        </div>}
                                                    </td>
                                                    <td id="editIconMainBody" className="tabledatamain">
                                                        <div id="editIconDiv">
                                                            <img src={this.state.hasAddRow ? require('../../../assets/images/cross.svg') : edit} class="editimagetable" alt=""
                                                                onClick={this.romoveAddRow}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            }
                                            {this.renderTableData()}
                                        </tbody>
                                    </table>
                                </div>
                                <hr id="maintainFacilityline" />
                                <div id="tableFootermain" style={{ display: !viewOnly ? "none" : null }}>
                                    <Link
                                        onClick={this.onAddHandleFacility}><img src={this.state.hasAddRow ? addDisable : add} alt="" width="19" height="19" id="addFacility" /> <small className="addFacilityText" style={{ color: this.state.hasAddRow ? "#B6B6B6" : "#428BCA" }}>Add Facility</small></Link>
                                    <div id="maintainFacilityButtonDiv" >
                                        <Button type="button" class="btn btn-sm p-1 pr-3 pl-3"
                                            id="maintainFacilityButtonText"
                                            onClick={this.handleSubmit}
                                            disabled={!this.validateFormFields()}
                                        >
                                            Confirm</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <SuccessModal hasOpen={this.state.confirmedHasOpen} onClick={this.onCloseConfirmed}>
                        <p className="confirmedText">Confirmed</p>
                    </SuccessModal>
                </div></div>
            </div >
        )
    }
}
function mapStateToProps(state) {
    return { data: state.adminRoleReducer.roleData }
}
export default connect(mapStateToProps)(MaintainFacility);